import React from "react";
import { filterFields, schema } from "../../../../config/schema";
import {
  getSectionConstant,
  SECTION_CONSTANT_TYPE,
} from "../../../../../shared/util/constants/section";
import { PROGRAM_TYPE } from "../../../../../shared/util/constants/programType";
import { ISV_WORKLOAD_MIGRATION_PROGRAM_NAME } from "../../../../../shared/util/constants/subProgram";
import { uiToApiMap } from "../../../../../shared/util/adapter/toUi/adapter";
import { ColumnLayout, ExpandableSection } from "@amzn/awsui-components-react";
import Header from "@amzn/awsui-components-react/polaris/header";
import Button from "@amzn/awsui-components-react/polaris/button";
import PropTypes from "prop-types";
import { ValueFactory } from "./ValueFactory";
import { useHistory, useParams } from "react-router-dom";
import { createValueField } from "../../../../../shared/components/Review/CreateValueField";
import { canEdit } from "../util";
import { isFeatureEnabled } from "../../../../../shared/util/services/features/FeatureFlagsService";
import { FEATURE_FLAG_ENUMS } from "../../../../../shared/util/constants/featureFlagValues";

export const DefaultReviewSectionContainer = ({
  fundingData,
  index,
  step,
  template,
}) => {
  const [isSimplifiedCreditEnabled, setIsSimplifiedCreditEnabled] = React.useState(false);
  const [isMPOPPEnabled, setIsMPOPPEnabled] = React.useState(false);
  React.useEffect(async () => {
    setIsSimplifiedCreditEnabled(
      await isFeatureEnabled(FEATURE_FLAG_ENUMS.SIMPLIFY_ISV_CREDIT_REQUEST_ENABLED)
    );
    setIsMPOPPEnabled(
      await isFeatureEnabled(FEATURE_FLAG_ENUMS.MPOPP_ENABLED)
    );
  }, []);

  const history = useHistory();
  const { id } = useParams();
  const fields = [];

  for (let sectionTitle of template[step].sections) {
    const sectionName = getSectionConstant({
      type: SECTION_CONSTANT_TYPE.NAME,
      value: sectionTitle,
    });

    const apiKey = uiToApiMap[sectionName];

    const filteredFields = filterFields({
      section: schema[sectionTitle],
      program: fundingData.program,
    });

    for (let field of filteredFields) {
      // Boolean on whether or not to hide valuePerCode and numberOfCodes fields for ISV WMP
      const activateSimplifyCredit = isSimplifiedCreditEnabled && 
        fundingData.program === PROGRAM_TYPE.MISC && 
        fundingData.fundingTemplate &&
        fundingData.fundingTemplate.subProgram === ISV_WORKLOAD_MIGRATION_PROGRAM_NAME &&
        ["valuePerCode", "numberOfCodes"].includes(field.name);

      // Check if finalCreditAmount and agreementContractValue fields should be hidden
      const hideFinalCreditAmount = (field.name === "finalCreditAmount" || field.name === "agreementContractValue") &&
        (!isMPOPPEnabled || 
         fundingData.program !== PROGRAM_TYPE.PIF || 
         !fundingData.fundingTemplate || 
         !['MPOPP Activate', 'MPOPP Grow'].includes(fundingData.fundingTemplate.subProgram));

      if (activateSimplifyCredit || hideFinalCreditAmount) {
        continue;
      }

      fields.push(
        createValueField({
          field,
          value: ValueFactory({
            apiKey,
            sectionTitle,
            name: field.name,
            data: fundingData,
            field,
          }),
        })
      );
    }
  }

  return (
    <React.Fragment key={index}>
      <ExpandableSection
        variant="container"
        defaultExpanded={true}
        header={
          <Header
            actions={
              canEdit({
                status: fundingData["status"],
                stage: fundingData["stage"],
              }) ? (
                <Button
                  onClick={() =>
                    history.push(
                      `/fund-request/${id}/${template[step].name}/edit`
                    )
                  }
                >
                  Edit
                </Button>
              ) : (
                ""
              )
            }
          >
            {template[step].title}
          </Header>
        }
      >
        <ColumnLayout columns={4} variant="text-grid">
          {fields}
        </ColumnLayout>
      </ExpandableSection>
      <br />
    </React.Fragment>
  );
};

DefaultReviewSectionContainer.propTypes = {
  fundingData: PropTypes.object,
  index: PropTypes.number,
  step: PropTypes.array,
  template: PropTypes.object,
};
